import React from "react";
import styles from "./Music.module.css";

const Music = () => {
    return (
        <div className={styles.musicContainer}>
             Music
        </div>
    )
}

export default Music;